import styled from 'styled-components';
import { Card } from '../main/CommonStyles';

export const DetailWrapper = styled.div`
    max-width: 900px;
    margin: 0 auto;
`;

export const CaseHeader = styled(Card)`
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    background: linear-gradient(135deg, ${({ theme }) => theme.colors.primaryLightest}, #fff);

    h2 {
        font-size: 1.75rem;
        color: ${({ theme }) => theme.colors.primaryDarker};
        margin: 0;
    }
`;

export const StatusGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 1rem;
    margin-top: 1.5rem;
    border-top: 1px solid ${({ theme }) => theme.colors.borderColor};
    padding-top: 1.5rem;
`;

export const InfoBox = styled.div`
    font-size: 0.95rem;
    
    .label {
        font-weight: 700;
        color: ${({ theme }) => theme.colors.textMedium};
        display: block;
        margin-bottom: 0.25rem;
    }

    .value {
        font-weight: 600;
        color: ${({ theme }) => theme.colors.textDark};
    }
`;

export const TimelineWrapper = styled.div`
    margin-top: 2rem;
`;

export const CommentCard = styled(Card)`
    padding: 1.25rem;
    margin-bottom: 1.25rem;
    position: relative;
    border-left: 4px solid ${({ theme, $isOwn }) => $isOwn ? theme.colors.secondary : theme.colors.primary};
    background-color: ${({ theme, $isOwn }) => $isOwn ? '#f0fdf4' : theme.colors.white};

    .comment-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.75rem;
        font-size: 0.9rem;
    }

    .author {
        font-weight: 800;
        color: ${({ theme, $isOwn }) => $isOwn ? theme.colors.secondaryDark : theme.colors.primaryDark};
    }

    .timestamp {
        font-weight: 500;
        color: ${({ theme }) => theme.colors.textMedium};
    }

    .content {
        color: ${({ theme }) => theme.colors.textDark};
        line-height: 1.6;
        white-space: pre-wrap;
    }
`;

export const AddCommentWrapper = styled(Card)`
    margin-top: 2rem;
    
    textarea {
        width: 100%;
        min-height: 100px;
        padding: 0.75rem;
        border-radius: ${({ theme }) => theme.borderRadius};
        border: 2px solid ${({ theme }) => theme.colors.borderColor};
        font-size: 1rem;
        resize: vertical;

        &:focus {
            outline: none;
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }

    button {
        margin-top: 1rem;
    }
`;